import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, selectedIds, theme) {
  return {
    fontWeight: selectedIds.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

export default function MultipleSelect({ objectMap, setIds, workerIds }) {
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  // Initialize selected values from props
  React.useEffect(() => {
    if (workerIds && Array.isArray(workerIds)) {
      setPersonName(workerIds);
    }
  }, [workerIds]);

  // Notify parent when selected values change
  React.useEffect(() => {
    setIds(personName);
  }, [setIds, personName]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-name-label">Worker</InputLabel>
        <Select
          labelId="demo-multiple-name-label"
          id="demo-multiple-name"
          multiple
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput label="Name" />}
          MenuProps={MenuProps}
        >
          {objectMap.map((object) => (
            <MenuItem
              key={object.id}
              value={object.id}
              style={getStyles(object.id, personName, theme)}
            >
              {object.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
